<template>
  <div>
    <div v-if="items.length" class="p-3">
      <time-line class="px-3">
        <time-line-item
          v-for="item of items"
          :key="item.id"
          icon="fas fa-exchange-alt"
        >
          <template #date>
            <span class="data-name">Fecha:</span>
            <p class="color-black font-16">
              {{
                $formatDate(item.createdDate, $templateDate.longDateWithHour)
              }}
            </p>
          </template>

          <div class="row align-items-center">
            <div class="col-12 col-md">
              <div class="data-name">Estatus:</div>
              <custom-balloon
                :background-color="item.status?.color"
                class="text-nowrap"
                dot
                :text="item.status?.name"
              />
            </div>
            <div class="col-12 col-md">
              <div class="data-name">Usuario:</div>
              <div>
                {{ item.userFullName | capitalize }}
              </div>
            </div>
            <div v-if="item.comment" class="col-12 mt-3 bg-white rounded p-3">
              <div class="data-name">
                <i class="fas fa-info-circle mr-2 text-orange" />
                Comentario:
              </div>
              <div>
                {{ item.comment | empty }}
              </div>
            </div>
          </div>
        </time-line-item>
      </time-line>
      <div v-if="hasMore" class="my-4 d-flex justify-content-center">
        <action-button
          i="fas fa-chevron-down"
          variant="outline-success rounded-pill"
          @click="load"
        >
          Ver más
        </action-button>
      </div>
    </div>
    <custom-result-not-found v-else text="No hay Información Disponible." />
  </div>
</template>

<script>
//components
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomBalloon from 'custom-balloon';
import ActionButton from 'ActionButton';
import CustomResultNotFound from 'custom-result-not-found';

export default {
  name: 'MedicaidClaimBatchDetailHistory',
  components: {
    TimeLine,
    TimeLineItem,
    CustomBalloon,
    ActionButton,
    CustomResultNotFound,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    page() {
      return this.data.page;
    },
    total() {
      return this.data.total;
    },
    items() {
      return this.data.items;
    },
    hasMore() {
      return this.total > this.items.length;
    },
  },
  beforeDestroy() {
    this.$emit('clean');
  },
  methods: {
    load() {
      this.$emit('load', this.page + 1);
    },
  },
};
</script>
<style scoped>
::v-deep .icon-mr-0 {
  margin-right: 0 !important;
}
</style>
